module.exports = __webpack_public_path__ + "img/el-0-b-3572-ok-copy-2-xs.d71a7384.jpg";